<template>
  <div class="screening-fdbck">
    <div class="mobpx0 px-4 py-3 givef-right-overflow position-relative">
      <div class="position-relative" v-if="feedbacktype == 'true'">
        <label class="teams-label-font mb-2"
          >Recommendation <span class="asterik">*</span></label
        >
        <div class="position-relative">
          <selectCustom
            placeholder="Choose recommendation"
            :noLabel="true"
            :dropdown="true"
            :values="recommendations"
            :vmodel="validate.feedback.recommendation.$model"
            @select-value="feedback.recommendation = $event"
            :showError="validate.feedback.recommendation.$error"
            :disabled="screenData.submitted"
            :disableDropdown="screenData.submitted"
          />
          <div
            class="errortxt position-absolute"
            v-if="validate.feedback.recommendation.$error"
          >
            Required
          </div>
        </div>
      </div>

      <div v-else class="mr-2">
        <b-form-group
          class="panlogradio"
          :class="{
            'panlogradio-err':
              validate.feedback.recommendation.$dirty &&
              !validate.feedback.recommendation.required,
          }"
          v-slot="{ ariaDescribedby }"
        >
          <div class="teams-label-font">
            Recommendation<span class="asterik">*</span>
          </div>
          <div
            class="
              fdf-add-container
              mt-2
              w-50
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <b-form-radio
              v-model="feedback.recommendation"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              :disabled="screenData.submitted"
              value="S"
              >Select</b-form-radio
            >
            <b-form-radio
              v-model="feedback.recommendation"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              :disabled="screenData.submitted"
              value="R"
              >Reject</b-form-radio
            >
          </div>
        </b-form-group>
      </div>
      <div class="newmodalinputbox position-relative">
        <label class="givef-head mt-3"
          >Remarks <span class="asterik">*</span></label
        >
        <b-form-textarea
          no-resize
          placeholder="Enter"
          v-model="validate.feedback.recommendationComments.$model"
          :class="{
            error: validate.feedback.recommendationComments.$error,
          }"
          :disabled="screenData.submitted"
        ></b-form-textarea>
        <div
          class="errortxt position-absolute"
          v-if="validate.feedback.recommendationComments.$error"
        >
          Required
        </div>
      </div>
      <hr />
      <div
        v-if="!screenData.submitted"
        class="givef-blue-skill pointer"
        :class="{
          error:
            validate.feedback.skills.$dirty &&
            !validate.feedback.skills.required,
        }"
        @click="addNewSkill"
      >
        <img src="../../assets/add-skill.svg" alt="" />Add New Skill
      </div>
      <div v-else class="givef-blue-skill pointer">Skills</div>
      <div
        v-for="(skills, index) in feedback.skills"
        :key="index"
        class="givef-feedback-card"
        :class="{
          'disablefeedbackcard defaultcursor': screenData.submitted,
        }"
      >
        <div
          class="
            d-flex
            align-items-center
            justify-content-between
            mobflexcolumn
          "
        >
          <b-form-input
            :disabled="screenData.submitted"
            v-model="validate.feedback.skills.$each[index].name.$model"
            placeholder="Skill name"
            class="mobw100 mobmt1 oneline-inputField"
            :class="{
              'oneline-error':
                validate.feedback.skills.$each[index].name.$error,
            }"
          >
          </b-form-input>
          <div class="d-flex align-items-center mobw100 mobmt3">
            <h5 class="mb-0 givef-rating-txt mr-2 mobmr-0">Rating</h5>
            <div class="feedback-rating mr-2">
              <b-form-rating
                :readonly="screenData.submitted"
                v-model="validate.feedback.skills.$each[index].mark.$model"
                :variant="
                  validate.feedback.skills.$each[index].mark.$error
                    ? 'danger'
                    : 'primary'
                "
              ></b-form-rating>
            </div>
            <img
              v-show="!screenData.submitted"
              src="../../assets/talentpool/Delete.svg"
              alt=""
              class="pointer"
              @click="deleteSkill(index)"
            />
          </div>
        </div>
        <div
          class="mt-2 position-relative"
          :class="{
            'mb-2': validate.feedback.skills.$each[index].comments.$error,
            'viewfdbck-txtarea': screenData.submitted,
            newmodalinputbox: !screenData.submitted,
          }"
        >
          <div class="diable-cmnt-txt mt-2" v-if="screenData.submitted">
            Comments:
          </div>
          <b-form-textarea
            no-resize
            placeholder="Comments"
            :disabled="screenData.submitted"
            v-model="validate.feedback.skills.$each[index].comments.$model"
            :class="{
              error: validate.feedback.skills.$each[index].comments.$error,
            }"
          ></b-form-textarea>
          <div
            class="errortxt position-absolute"
            v-if="validate.feedback.skills.$each[index].comments.$error"
          >
            Required
          </div>
        </div>
      </div>
    </div>
    <footer class="givef-footer">
      <b-button
        v-if="!screenData.submitted"
        class="new-blueBtn px-5"
        @click="$emit('submit-feedback')"
      >
        <span class="px-4">Send</span>
      </b-button>
      <b-button v-else class="new-blueBtn px-5" @click="$emit('go-back')">
        <span class="px-4">Back</span>
      </b-button>
    </footer>
  </div>
</template>

<script>
import SelectCustom from "../../components/InputComponents/SelectCustom.vue";
export default {
  name: "Feedback",
  components: {
    SelectCustom,
  },
  props: {
    validate: Object,
    feedback: Object,
    screenData: Object,
    feedbacktype: String,
  },
  data() {
    return {
      recommendations: [
        { label: "Strongly select", key: "SS" },
        { label: "Select", key: "S" },
        { label: "Strongly reject", key: "SR" },
        { label: "Reject", key: "R" },
      ],
    };
  },
  methods: {
    addNewSkill() {
      this.feedback.skills.push({
        name: "",
        mark: 0,
        comments: "",
        markingType: "rating",
      });
      this.$nextTick(() => {
        const index = this.feedback.skills.length - 1;
        const skillValidation = this.validate.feedback.skills.$each[index];

        if (skillValidation && skillValidation.$reset) {
          skillValidation.$reset(); // ✅ This clears dirty/error state for new field
        }
      });
    },
    deleteSkill(index) {
      this.feedback.skills.splice(index, 1);
      this.$nextTick(() => {
        if (this.feedback.skills.length === 0) {
          this.validate.feedback.skills.$reset?.();
        }
      });
    },
  },
};
</script>
<style>
.givef-right-overflow {
  height: calc(100vh - 302px);
  overflow: auto;
}
@media (max-width: 1028px) {
  .mobflexcolumn {
    flex-direction: column;
  }
  .mobmr-0 {
    margin-right: 0;
  }
  .mobw100 {
    width: 100%;
  }
  .mobmt3 {
    margin-top: 1rem;
  }
  .mobmt1 {
    margin-top: 0.25rem;
  }
  .givef-right-overflow {
    height: calc(100dvh - 180px);
  }
  .mobpx0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
</style>
